<template>
  <div :style="marketDetails">
    <table
      v-if="race.fileType === 'resultprovisional'"
      class="market"
    >
      <tr class="market-row-provisional">
        <td>
          <div>
            PROVISIONAL RESULT
          </div>
        </td>
      </tr>
    </table>

    <table
      v-if="race.fileType === 'resultfinal'"
      class="market"
    >
      <tr class="market-row-final">
        <td>
          <div>
            FINAL RESULT
          </div>
        </td>
      </tr>
    </table>

    <table
      v-if="race.fileType === 'resultfinal' || race.fileType === 'resultprovisional'"
      class="market"
    >
      <tr
        v-if="race.h1"
        class="market-row"
      >
        <td class="number">
          1st
        </td>

        <td class="runner">
          <div class="name">
            {{ parseInt(race.h1.num, 10) }} {{ race.h1.name }}
          </div>
        </td>

        <td class="name-spacer" />

        <td class="price">
          {{ race.h1.startingPrice }}
        </td>

        <td class="place">
          <div v-if="race.placeData && race.placeData.placesPaid >= 1">
            {{ placeDisplayPrice(race.h1, race.placeData) }}
          </div>
        </td>
      </tr>

      <tr
        v-if="race.h2"
        class="market-row"
      >
        <td class="number">
          2nd
        </td>

        <td class="runner">
          <div class="name">
            <span class="num">{{ parseInt(race.h2.num, 10) }}</span> {{ race.h2.name }}
          </div>
        </td>

        <td class="name-spacer" />

        <td class="price">
          {{ race.h2.startingPrice }}
        </td>

        <td class="place">
          <div v-if="race.placeData && race.placeData.placesPaid >= 2">
            {{ placeDisplayPrice(race.h2, race.placeData) }}
          </div>
        </td>
      </tr>

      <tr
        v-if="race.h3"
        class="market-row"
      >
        <td class="number">
          3rd
        </td>

        <td class="runner">
          <div class="name">
            {{ parseInt(race.h3.num, 10) }} {{ race.h3.name }}
          </div>
        </td>

        <td class="name-spacer" />

        <td class="price">
          {{ race.h3.startingPrice }}
        </td>

        <td class="place">
          <div v-if="race.placeData && race.placeData.placesPaid >= 3">
            {{ placeDisplayPrice(race.h3, race.placeData) }}
          </div>
        </td>
      </tr>

      <tr
        v-if="race.h4"
        class="market-row"
      >
        <td class="number">
          4th
        </td>

        <td class="runner">
          <div class="name">
            {{ parseInt(race.h4.num, 10) }} {{ race.h4.name }}
          </div>
        </td>

        <td class="name-spacer" />
        <td class="price">
          {{ race.h4.startingPrice }}
        </td>

        <td class="place">
          <div v-if="race.placeData && race.placeData.placesPaid >= 4">
            {{ placeDisplayPrice(race.h4, race.placeData) }}
          </div>
        </td>
      </tr>
    </table>

    <table
      v-if="race.fileType === 'racecard'"
      class="market"
    >
      <tr class="market-row">
        <td class="runner">
          <div class="name">
            Awaiting Results
          </div>
        </td>
      </tr>
    </table>
    <div class="clearfix" />
  </div>
</template>

<script>
export default {
  name: 'Resultmarket',
  props: ['race', 'placePercentage'],
  data() {
    return {
      market: null
    };
  },
  computed: {
    marketDetails() {
      return this.$store.getters.marketDetails;
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
    placeDisplayPrice(market, placeData) {
      const price = this.market ? this.market.price : -1;
      const fraction = this.$store.state.fractionTable.find(fraction => price >= fraction.priceFrom && price <= fraction.priceTo);

      return fraction && this.$store.state.screenConfig.placePriceDisplay === 'fraction'
        ? fraction.numerator + '/' + fraction.denominator
        : this.placePricePercentage(market, placeData);
    },
    placePricePercentage(market, placeData) {
      if (market.startingPrice) {
        return +(market.startingPrice * (placeData.placePercentage / 100)).toFixed(2);
      }
    }
  }
};
</script>
<style scoped>
.market {
    table-layout: fixed;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
}

.market-row-provisional {
    background-color: orange;
    height: 50px;
    text-align: center;
    font-weight: bold;
    font-size: 28px;
}
.market-row-final {
    background-color: green;
    height: 50px;
    text-align: center;
    font-weight: bold;
    font-size: 28px;
}

.market-row {
    border-bottom: 1px solid #000;
    height: 60px;
}

.silk {
    width: 50px;
    padding-left: 10px;
}

.number {
    font-size: 40px;
    width: 60px;
    padding-left: 10px;
    text-align: center;
    padding-right: 20px;
}

.num {
    padding-right: 20px;
}

.runner {
    overflow: hidden;
    white-space: nowrap;
    padding-left: 10px;
}

.name {
    font-size: 28px;
    font-weight: bold;
    padding-top: 2px;
    height: 30px;
    line-height: 30px;
    padding-left: 50px;
}

.data {
    font-size: 15px;
    line-height: 25px;
    font-style: italic;
}

.market-data-jockey {
    margin-right: 10px;
}

.market-data-trainer {
    margin-left: 10px;
}

.name-spacer {
    width: 10px;
}

.price {
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    width: 90px;
}

.odds-on-price {
    color: red;
}

.prev {
    font-size: 28px;
    padding-top: 4px;
    text-align: center;
    width: 70px;
}

.place {
    font-size: 20px;
    padding-top: 7px;
    text-align: center;
    width: 70px;
}

.scratched {
    text-decoration: line-through;
}
</style>


// WEBPACK FOOTER //
// ResultMarket.vue?8459f890